var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._v(" shop ")])
}
var staticRenderFns = []

export { render, staticRenderFns }